import React from "react";
import { Link } from "react-router-dom";

const PageError = () => {
    document.title = "404 - Page Not Found";

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center" id="page-error">
            <div className="text-center">
                <div className="mb-4">
                    <i className="fa-solid fa-triangle-exclamation text-danger" style={{ fontSize: "5rem" }}></i>
                </div>

                <h1 className="display-4 fw-bold">404</h1>
                <h3 className="mb-3">Page Not Found</h3>
                <p className="text-muted mb-4">Sorry, the page you are looking for doesn't exist or has been moved.</p>
                <Link to="/" className="btn btn-primary px-4 d-inline-flex">
                    <i className="me-2 fa fa-home"></i>
                    <span>Back to Home</span>
                </Link>

            </div>
        </div>
    );
};

export default PageError;
